<template>
  <div class="lm-bar-container">
    <div class="lm-bar-item">
      <div  class="lm-bar-l"
            :style="{ 'width': `${getValue()}%`, 'background': `${getLeftBarColor()}` }">
      </div>
      <div  class="lm-bar-r"
            :style="{ 'width': `${getRest()}%`, 'background': `${getRightBarColor()}` }">
      </div>
    </div>
    <div class="lm-bar-text">
      {{ (val != undefined) ? $n(val, { minimumFractionDigits: 0, maximumFractionDigits: 0}) : '&nbsp;' }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    val: { default: undefined },
    thresholds: { type: Array, required: true }
  },

  methods: {
    getRightBarColor() {
      return this.thresholds.find(s => s.Smiley == "frown-open")?.Color;
    },
    
    getLeftBarColor() {
      return this.thresholds.find(s => s.Smiley == "grin")?.Color;
    },
    
    getRest() {
      return 100 - this.val;
    },
    getValue() {
      return this.val;
    }
  }
}
</script>
